import menu from './menu'
import reports from './reports'
import balance from './balance'
import prices from './prices'
import categories from './categories'
import areas from './areas'
import recipes from './recipes'
import subrecipes from './subrecipes'
import ingredients from './ingredients'
import sections from './sections'
import dishes from './dishes'
import inventory from './inventory'
import intelligentPurchase from './intelligentPurchase'
import production from './production'
import decrease from './decrease'
import orders from './orders'
import sales from './sales'
import combos from './combos'
import products from './products'
import auth from './auth'
import validations from './validations'
import deposits from './deposits'
import issues from './issues'
import expenses from './expenses'
import income from './income'
import accounting from './accounting'
import purchases from './purchases'
import myRestaurants from './my-restaurants'
import pos from './pos'
import management from './management'
import taxes from './taxes'
import components from './components'

const es = {
  messages: {
    isRequired: 'es requerido',
    yes: 'Sí',
    no: 'No'
  },
  ctas: {
    confirmed: 'Confirmar',
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    add: 'Agregar'
  },
  menu,
  prices,
  categories,
  areas,
  recipes,
  subrecipes,
  ingredients,
  sections,
  dishes,
  inventory,
  intelligentPurchase,
  production,
  decrease,
  orders,
  sales,
  combos,
  balance,
  reports,
  auth,
  products,
  validations,
  deposits,
  issues,
  expenses,
  income,
  accounting,
  purchases,
  myRestaurants,
  pos,
  taxes,
  components,
  management
}

export default es
